import { combineReducers } from 'redux';
import errorReducer from './errorReducer';
import authReducer from './authReducer';
import savedJobReducer from './saved-jobs';

export default combineReducers({
    errors: errorReducer,
    auth: authReducer,
    savedJob:savedJobReducer
});